import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import { SEOHead } from "@/components/SEOHead";
import { InViewLoader } from "@/components/InViewLoader";

// Lazy load below-the-fold components
const HolographicShowcase = lazy(() => import("@/components/HolographicShowcase"));
const ModulesSection = lazy(() => import("@/components/ModulesSection"));
const HowItWorksSection = lazy(() => import("@/components/HowItWorksSection"));
const PlatformSection = lazy(() => import("@/components/PlatformSection"));
const VRLabSection = lazy(() => import("@/components/VRLabSection"));
const CollaborationSection = lazy(() => import("@/components/CollaborationSection"));
const ClientsSection = lazy(() => import("@/components/PartnersSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const Footer = lazy(() => import("@/components/Footer"));

const schemaOrg = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "VRxED",
  "url": "https://vrxed.com",
  "logo": "https://vrxed.com/favicon.ico",
  "description": "Immersive VR medical education platform for healthcare professionals.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Mohali",
    "addressRegion": "Chandigarh",
    "addressCountry": "IN"
  },
  "sameAs": [
    "https://learning.vrxed.com"
  ]
});

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="VRxED – Immersive VR Medical Education Platform"
        description="VRxED transforms healthcare training with immersive VR simulations, AI medical tools, and multilingual collaboration for institutions worldwide."
        canonical="https://vrxed.com/"
        schemaJson={schemaOrg}
      />
      {/* Visually hidden H1 for SEO – the animated hero text counts as design, not semantic heading */}
      <h1 className="sr-only">VRxED – Immersive Virtual Reality Medical Education Platform</h1>
      <Navbar />
      <main className="relative">
        <HeroSection />
        
        {/* Render below-the-fold content asynchronously.
            id props on InViewLoader put the anchor on the wrapper div so
            document.getElementById works before the lazy child mounts. */}
        <Suspense fallback={<div className="min-h-[200vh] bg-background" />}>
          <InViewLoader><HolographicShowcase /></InViewLoader>
          <InViewLoader id="modules"><ModulesSection /></InViewLoader>
          <InViewLoader id="how-it-works"><HowItWorksSection /></InViewLoader>
          <InViewLoader id="platform"><PlatformSection /></InViewLoader>
          <InViewLoader><CollaborationSection /></InViewLoader>
          <InViewLoader><VRLabSection /></InViewLoader>
          <InViewLoader><ClientsSection /></InViewLoader>
          <InViewLoader id="contact"><ContactSection /></InViewLoader>
          <InViewLoader><Footer /></InViewLoader>
        </Suspense>
      </main>
    </div>
  );
};

export default Index;
